export { default } from './parts-table-body';
